module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['flexRow', 'blockRow', _vm.color]
  }, [_vm._l((_vm.blocks), function(block, key) {
    return _c('block', {
      attrs: {
        "block": block,
        "blockId": key,
        "categoryId": _vm.categoryId,
        "customDate": _vm.customDate,
        "color": _vm.color
      }
    })
  }), _vm._v(" "), _vm._l((_vm.numRemaining), function(n) {
    return _c('new-block', {
      class: ['quota', _vm.isQuotaMet ? 'quotaMet' : ''],
      attrs: {
        "categoryId": _vm.categoryId,
        "customDate": _vm.customDate
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e427ee6!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/BlockRow.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-9e427ee6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/BlockRow.vue
// module chunks = 0